import type { ChangeEvent, RefObject } from "react";
import { useRef, useState } from "react";
import { UserMenu } from "./user-menu";
import { DivBackDrop } from "~/components/blocks/layout/global-navi/common/common-style";
import { RightIcons } from "~/components/blocks/layout/global-navi/common/right-icons";
import { useEffectSearchFormState } from "~/components/blocks/layout/global-navi/mobile/right/hooks/use-effect-search-form-state";
import { SearchForm } from "~/components/blocks/layout/global-navi/mobile/right/search-form";

export type RightProps = {
  isVisibleSearch: boolean;
  isShowSearch: boolean;
  searchButtonRef: RefObject<HTMLButtonElement>;
  isShowDmmService: boolean;
  onToggleSearch: () => void;
  onHideSearch: () => void;
  onToggleDmmService: () => void;
};

export const Right = (props: RightProps) => {
  const {
    isShowDmmService,
    isShowSearch,
    isVisibleSearch,
    searchButtonRef,
    onToggleDmmService,
    onToggleSearch,
    onHideSearch,
  } = props;

  /** Dmm Service */
  const hideDmmServiceMenu = () => {
    if (isShowDmmService) onToggleDmmService();
  };
  /** User Menu */
  const userMenuButtonRef = useRef<HTMLButtonElement>(null);
  const [isShowUserMenu, setIsShowUserMenu] = useState(false);
  const onHideUserMenu = () => {
    setIsShowUserMenu(false);
  };
  /** Search Form */
  const [searchKeyword, setSearchKeyword] = useState("");
  const onChangeKeyword = (e: ChangeEvent<HTMLInputElement>) => setSearchKeyword(e.currentTarget.value);
  const onOverWriteKeyword = (text: string) => setSearchKeyword(text);
  useEffectSearchFormState({ onOverWriteKeyword, onHideSearch });

  return (
    <>
      {!isShowSearch && (
        <RightIcons
          userMenuButtonRef={userMenuButtonRef}
          searchButtonRef={searchButtonRef}
          onDisplayUserMenu={() => {
            hideDmmServiceMenu();
            setIsShowUserMenu((prev) => !prev);
          }}
          onDisplaySearch={() => {
            hideDmmServiceMenu();
            onToggleSearch();
          }}
        />
      )}

      {isShowUserMenu && (
        <>
          <UserMenu userMenuButtonRef={userMenuButtonRef} onHideUserMenu={onHideUserMenu} />
          <DivBackDrop />
        </>
      )}

      {isVisibleSearch && (
        <SearchForm
          isShowSearch={isShowSearch}
          keyword={searchKeyword}
          onChangeKeyword={onChangeKeyword}
          onOverWriteKeyword={onOverWriteKeyword}
          onHideSearch={onHideSearch}
        />
      )}
    </>
  );
};
